import { LocalCanalConfiguracion, LocalCanalConfiguracionForm } from '@models/.';

export function transformToData(localChannel: LocalCanalConfiguracion | null): LocalCanalConfiguracion | null {
  if (!localChannel) return null;
  
  return {
    ...localChannel,
  };
}

export function transformToForm(localChannel: LocalCanalConfiguracionForm | null): LocalCanalConfiguracionForm | null {
  if (!localChannel) return null;
  
  return {
    ...localChannel,
  };
}


export function transformLocalChannelToName(localChannels: LocalCanalConfiguracion[]): string[] {

  return localChannels.map((channel) => channel.nombre);
}